import {
  Component,
  ViewChild,
  AfterViewInit,
  Input,
  ElementRef,
  TemplateRef,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import _get from 'lodash-es/get';
import { NgSignaturePadOptions, SignaturePadComponent } from '@almothafar/angular-signature-pad';

@Component({
  selector: 'cm-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss'],
})
export class SignatureComponent implements AfterViewInit, OnChanges {
  @ViewChild('signatureCanvas', { static: true }) signaturePad: SignaturePadComponent;
  @ViewChild('signatureContainer') signatureContainer: ElementRef;
  @Input()
  options: NgSignaturePadOptions = {
    penColor: 'rgb(0, 0, 0)',
    backgroundColor: 'rgb(255, 255, 255)',
    canvasWidth: 500,
    canvasHeight: 200,
  };
  @Input() editable = true;
  @Input() disabled = false;
  @Input() introTmpl: TemplateRef<any>;

  private isResized = false;
  private _signature = '';
  private readonly MAX_LENGTH = 30000;
  private readonly errors = {
    emptySign: 'Please sign in form above.',
    longSign: 'Please provide a valid signature within the box provided.',
  };

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.editable.currentValue && this.isResized) {
      const { canvasContext } = this.getCanvasAndContext();
      canvasContext.scale(
          this.options.canvasWidth / this.signatureContainer.nativeElement.clientWidth,
          this.options.canvasHeight / this.signatureContainer.nativeElement.clientHeight,
      );
      this.isResized = false;
    }
  }

  ngAfterViewInit() {
    if (!this.editable) {
      this.signaturePad.off();
    }
    this.signaturePad.set('canvasWidth', this.signatureContainer.nativeElement.clientWidth);
    this.signaturePad.set('canvasHeight', this.signatureContainer.nativeElement.clientHeight);
    this.signaturePad.clear();
    if (this.disabled) {
      const { canvas, canvasContext } = this.getCanvasAndContext();
      if (canvasContext) {
        canvasContext.fillStyle = '#e9ecef';
        canvasContext.fillRect(0, 0, canvas.width, canvas.height);
      }
    }
  }

  get signature() {
    return this._signature;
  }

  set signature(value) {
    if (value && !this.isResized) {
      this.correctCanvasScale();
    }
    this._signature = value;
    this.signaturePad.fromDataURL(value);
  }

  correctCanvasScale() {
    const { canvasContext } = this.getCanvasAndContext();
    canvasContext.scale(
        this.signatureContainer.nativeElement.clientWidth / this.options.canvasWidth,
        this.signatureContainer.nativeElement.clientHeight / this.options.canvasHeight,
    );
    this.isResized = true;
  }

  getCanvasAndContext() {
    const signaturePadElement: Element = _get(this.signaturePad, 'elementRef.nativeElement');
    const canvas = signaturePadElement && signaturePadElement.querySelector('canvas');
    const canvasContext = canvas && canvas.getContext('2d');
    return { canvas, canvasContext };
  }

  getSignatureErrors(): string | null {
    if (!this._signature || this.signature.length === 0) {
      return this.errors.emptySign;
    }

    if (this._signature && this._signature.length > this.MAX_LENGTH) {
      return this.errors.longSign;
    }

    return null;
  }

  drawComplete() {
    this._signature = this.signaturePad.toDataURL();
  }

  clearSignature() {
    this.signaturePad.clear();
    this._signature = '';
  }
}
